import React, { useEffect } from 'react';
import { create } from 'zustand';

type TMenuState = {
  menuOpened: boolean;
  setMenuOpened: (menuOpened: boolean) => void;
};

const menuStore = create<TMenuState>((set) => ({
  menuOpened: true,
  setMenuOpened: (menuOpened: boolean) => set({ menuOpened }),
}));

export const useMenuToggle = (isMenuOpened?: boolean) => {
  const menuOpened = menuStore((state) => state.menuOpened);
  const setMenuOpened = menuStore((state) => state.setMenuOpened);
  const isMenuOpenedRef = React.useRef(isMenuOpened);

  useEffect(() => {
    isMenuOpenedRef.current = isMenuOpened;
  }, [isMenuOpened]);

  useEffect(() => {
    if (isMenuOpenedRef.current === undefined) return;
    setMenuOpened(isMenuOpenedRef.current);
  }, [setMenuOpened]);

  return { menuOpened, setMenuOpened };
};
